export default "__VITE_ASSET__BPWiRdSN__"